import React from 'react';

const TermsOfServiceContent = () => {
  return (
    <div className="prose dark:prose-invert max-w-none">
      <h2 className="text-2xl font-bold mb-4">Terms of Service</h2>
      <p className="mb-2">
        <strong>Last updated: October 29, 2025</strong>
      </p>
      <p className="mb-4">
        Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the SceneShop Showcase Portal (the "Service") operated by Padam Technologies QFZ LLC ("us", "we", or "our").
      </p>
      <p className="mb-4">
        Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.
      </p>
      <p className="mb-4">
        By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
      </p>
      <h3 className="text-xl font-semibold mb-3">Accounts</h3>
      <p className="mb-4">
        When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
      </p>
      <p className="mb-4">
        You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.
      </p>
      <p className="mb-4">
        You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
      </p>
      <h3 className="text-xl font-semibold mb-3">Intellectual Property</h3>
      <p className="mb-4">
        The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of Padam Technologies QFZ LLC and its licensors.
      </p>
      <p className="mb-4">
        The Service is protected by copyright, trademark, and other laws of both the Qatar and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Padam Technologies QFZ LLC.
      </p>
      <h3 className="text-xl font-semibold mb-3">Links To Other Web Sites</h3>
      <p className="mb-4">
        Our Service may contain links to third-party web sites or services that are not owned or controlled by Padam Technologies QFZ LLC.
      </p>
      <p className="mb-4">
        Padam Technologies QFZ LLC has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that Padam Technologies QFZ LLC shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.
      </p>
      <p className="mb-4">
        We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.
      </p>
      <h3 className="text-xl font-semibold mb-3">Termination</h3>
      <p className="mb-4">
        We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
      </p>
      <p className="mb-4">
        Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.
      </p>
      <p className="mb-4">
        You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.
      </p>
      <p className="mb-4">
        You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
      </p>
      <h3 className="text-xl font-semibold mb-3">Governing Law</h3>
      <p className="mb-4">
        These Terms shall be governed and construed in accordance with the laws of Qatar, without regard to its conflict of law provisions.
      </p>
      <p className="mb-4">
        Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.
      </p>
      <h3 className="text-xl font-semibold mb-3">Changes</h3>
      <p className="mb-4">
        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
      </p>
      <p className="mb-4">
        By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
      </p>
      <h3 className="text-xl font-semibold mb-3">Contact Us</h3>
      <p className="mb-2">
        If you have any questions about these Terms, please contact us:
      </p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>By email: contact@padam.ai</li>
      </ul>
    </div>
  );
};

export default TermsOfServiceContent;
